import _defineProperty from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _regeneratorRuntime from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/regenerator/index.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { Resource } from '@rest-hooks/rest';
import glue from '../glue';

var ApplicationResource = /*#__PURE__*/function (_Resource) {
  _inherits(ApplicationResource, _Resource);

  var _super = _createSuper(ApplicationResource);

  function ApplicationResource() {
    _classCallCheck(this, ApplicationResource);

    return _super.call(this);
  }
  /** Perform network request and resolve with json body */


  _createClass(ApplicationResource, null, [{
    key: "fetchResponse",
    value: function fetchResponse(input, init) {
      var _a;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var config;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                config = {
                  headers: Object.assign({
                    'Content-Type': 'application/json'
                  }, init.headers)
                };
                _context.t0 = (_a = init.method) === null || _a === void 0 ? void 0 : _a.toLowerCase();
                _context.next = _context.t0 === 'post' ? 4 : _context.t0 === 'put' ? 7 : _context.t0 === 'patch' ? 10 : _context.t0 === 'delete' ? 13 : _context.t0 === 'options' ? 16 : 19;
                break;

              case 4:
                _context.next = 6;
                return glue.api.post(input.toString(), init.body, config);

              case 6:
                return _context.abrupt("return", _context.sent);

              case 7:
                _context.next = 9;
                return glue.api.put(input.toString(), init.body, config);

              case 9:
                return _context.abrupt("return", _context.sent);

              case 10:
                _context.next = 12;
                return glue.api.patch(input.toString(), init.body, config);

              case 12:
                return _context.abrupt("return", _context.sent);

              case 13:
                _context.next = 15;
                return glue.api.delete(input.toString(), config);

              case 15:
                return _context.abrupt("return", _context.sent);

              case 16:
                _context.next = 18;
                return glue.api.options(input.toString(), config);

              case 18:
                return _context.abrupt("return", _context.sent);

              case 19:
                _context.next = 21;
                return glue.api.get(input.toString(), config);

              case 21:
                return _context.abrupt("return", _context.sent);

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
  }, {
    key: "fetch",
    value: function fetch(input, init) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.fetchResponse(input, init);

              case 3:
                response = _context2.sent;
                return _context2.abrupt("return", response.data);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                throw _context2.t0;

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));
    }
  }, {
    key: "create",
    value: function create() {
      var resourceList = this.list();
      return _get(_getPrototypeOf(ApplicationResource), "create", this).call(this).extend({
        schema: this,
        update: function update(newResourceId) {
          return _defineProperty({}, resourceList.key({}), function () {
            var resourceIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            return [].concat(_toConsumableArray(resourceIds), [newResourceId]);
          });
        }
      });
    }
  }, {
    key: "createNoUpdate",
    value: function createNoUpdate() {
      return _get(_getPrototypeOf(ApplicationResource), "create", this).call(this);
    }
  }, {
    key: "urlRoot",
    get: function get() {
      return glue.host + 'api' + this.resource;
    }
  }]);

  return ApplicationResource;
}(Resource);

export { ApplicationResource as default };

ApplicationResource.fetchOptionsPlugin = function (options) {
  return glue.authentication.authenticate(options);
};